import { ActionType, createReducer } from "typesafe-actions";
import * as actions from "store/features/templates/overivew/overview.actions";
import { deleteTemplate, fetchTemplates } from "store/features/templates/overivew";
import { Template, UserGroup } from "api";
import { resetApiError } from "store/features/general";

type TemplatesAction = ActionType<typeof actions>;

export type TemplatesListState = Readonly<{
    hasError: boolean;
    isDeleting: boolean;
    isProcessing: boolean;
    emailTemplates: Template[];
    userGroups: UserGroup[];
}>;

export const templatesListInitialState: TemplatesListState = {
    hasError: false,
    isProcessing: false,
    isDeleting: false,
    emailTemplates: [],
    userGroups: [],
};

export const overviewReducer = createReducer<TemplatesListState, TemplatesAction>(templatesListInitialState)
    .handleAction(fetchTemplates.request, () => {
        return {
            ...templatesListInitialState,
            isProcessing: true,
        };
    })
    .handleAction(deleteTemplate.request, (state) => {
        return {
            ...state,
            isDeleting: true,
        };
    })
    .handleAction(fetchTemplates.success, (state, { payload }) => {
        return {
            ...state,
            isProcessing: false,
            emailTemplates: payload.templates,
            userGroups: payload.userGroups,
        };
    })
    .handleAction([fetchTemplates.failure, deleteTemplate.failure], (state) => {
        return {
            ...state,
            isProcessing: false,
            isDeleting: false,
            hasError: true,
        };
    })
    .handleAction(deleteTemplate.success as never, (state) => {
        return {
            ...state,
            isDeleting: false,
        };
    })
    .handleAction(resetApiError as never, (state) => {
        return {
            ...state,
            hasError: false,
        };
    });
